import React, { useState } from "react";
import { Button } from "antd";
import { Form } from "react-final-form";

import { FormField, FormFieldType, DownloadExcel } from "@components";
import { i18, trb } from "@utilities";
import { AllRisksCraScreen } from "../Modals/AllRisksCraScreen";

import "./TableFilters.less";

export const RiskSettingsTableFilter = ({
  onFilter,
  filterValues,
  handleDownload,
  isDownloadingExcel
}) => {
  const [allRisksCraScreenOpen, setAllRisksCraScreenOpen] = useState(false);
  return (
    <>
      <div className="config-settings-filter-container">
        <Form
          onSubmit={onFilter}
          render={({ handleSubmit }) => {
            return (
              <form className="my-3" onSubmit={handleSubmit}>
                <div className="d-flex align-items-center input-container">
                  <div>
                    <FormField
                      name="riskDescription"
                      component={FormFieldType.input}
                      title={i18.ApplicationsLabels.RiskDescription}
                      size="large"
                      defaultValue={filterValues.riskDescription}
                    />
                  </div>
                  <div className="align-self-center">
                    <FormField
                      name="isActual"
                      component={FormFieldType.checkbox}
                      inline={true}
                      defaultValue={filterValues.isActual}
                      label={trb(i18.ApplicationsLabels.isActualFilterInput)}
                    />
                  </div>
                  <div className="d-flex align-items-end button-container">
                    <Button htmlType="submit" type="primary">
                      {trb(i18.Buttons.Filter)}
                    </Button>
                    <DownloadExcel isLoading={isDownloadingExcel} handleDownload={handleDownload} />
                    <Button onClick={() => setAllRisksCraScreenOpen(true)}>
                      {trb(i18.Buttons.GetAllClientRisksScreen)}
                    </Button>
                  </div>
                </div>
              </form>
            );
          }}
        />
      </div>
      {allRisksCraScreenOpen && (
        <AllRisksCraScreen onClose={() => setAllRisksCraScreenOpen(false)} />
      )}
    </>
  );
};
